export const LINK_NEWS_DETAILS = '/news/';
export const LINK_NEWS_LIST = '/news';
export const LINK_OUR_STORY = '/our-story';
export const LINK_CSR = '/csr';
export const LINK_TEAM = '/team';